import { createSelector } from 'reselect';

import { StateType } from '../../index';
import { activeTabIndexSelector } from '../../EditorReducer/EditorSelector';

export const progressSelector = (state: StateType) => state.getIn(['simulation', 'progress']);

// @ts-ignore
export const percentageProgressSelector = createSelector(
  progressSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (progress, activeTabIndex: number) => (activeTabIndex >= 0 ? progress.getIn([activeTabIndex, 'percentageProgress']) : null)
);

// @ts-ignore
export const fetchingPercentageSelector = createSelector(
  progressSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (progress, activeTabIndex: number) => (activeTabIndex >= 0 ? progress.getIn([activeTabIndex, 'fetchingPercentage']) : null)
);

export const fetchingPostSelector = createSelector(
  progressSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (progress, activeTabIndex: number) => (activeTabIndex >= 0 ? progress.getIn([activeTabIndex, 'fetchingPost']) : null)
);

export const progressSimulationIdSelector = createSelector(
  progressSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (progress, activeTabIndex: number) => (activeTabIndex >= 0 ? progress.getIn([activeTabIndex, 'simulationId']) : null)
);

export const showLearnBoxSelector = createSelector(
  progressSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (progress, activeTabIndex: number) => (activeTabIndex >= 0 ? progress.getIn([activeTabIndex, 'showLearnBox']) : null)
);

export const showTutorialBoxSelector = createSelector(
  progressSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (progress, activeTabIndex: number) => (activeTabIndex >= 0 ? (progress.getIn([activeTabIndex, 'showTutorialBox']) as boolean) : null)
);
